import styled from "styled-components";

export const TextErrorStyle = styled.p`
  font-family: light-pro, sans-serif;
  color: red;
  font-size: 14px;
  margin-top: 15px;
  align-self: center;
`;
export const TextErrorStyle2 = styled.p`
  font-family: light-pro, sans-serif;
  color: red;
  font-size: 14px;
  align-self: center;
`;

export const TextErrorStyle3 = styled.p`
  font-family: light-pro, sans-serif;
  color: red;
  font-size: 12px;
  margin-top: 5px;
`;
